import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/CardGenerator.css';
import imgWpp  from '../../img/whatsappImg.png';

const WhatsAppShare = ({language}) => {
    const { t } = useTranslation();
    
    const message = `${t('card.msgWhatsApp1')}\n${t('card.msgWhatsApp2')}\n${t('wordings.email')}\n\n${t('card.msgWhatsApp3')}`;

    const handleClick = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    };

    return (
    <>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" />
        <button className='share-wpp' onClick={handleClick}>
            <img src={imgWpp} alt='whatsapp' className='wpp-image' />
           {/* <i className="fab fa-whatsapp"></i> */}
        </button>
    </>
    );
};

export default WhatsAppShare;
